import styled from "styled-components";

export const Container = styled.div``;

export const ContainerFlex = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;